import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'transition-expand',
  setup(__props) {

const enter = (element: Element) => {
    const width = getComputedStyle(element).width;
    const el = element as HTMLElement;

    el.style.width = width;
    el.style.position = "absolute";
    el.style.visibility = "hidden";
    el.style.height = null;

    const height = getComputedStyle(element).height;

    el.style.width = null;
    el.style.position = null;
    el.style.visibility = null;
    el.style.height = "0";

    getComputedStyle(element).height;

    requestAnimationFrame(() => {
        el.style.height = height;
    });
};

const afterEnter = (element: Element) => {
    const el = element as HTMLElement;
    el.style.height = null;
};

const leave = (element: Element) => {
    const height = getComputedStyle(element).height;
    const el = element as HTMLElement;

    el.style.height = height;

    getComputedStyle(element).height;

    requestAnimationFrame(() => {
        el.style.height = "0";
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "expand",
    onEnter: enter,
    onAfterEnter: afterEnter,
    onLeave: leave
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})